import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../pages/languagecontext";
import API from "../pages/Services/Baseservice";
import ClipLoader from "react-spinners/ClipLoader";
import SEO from "./SEO";
const CheckEligibility = ({ showHeader = true }) => {
  const { selectedLanguage } = useContext(LanguageContext);
  const [weblanguageratinglist, setWebLanguageRatingList] = useState("");
  const [webhighesteducation, setWebHeightEducation] = useState("");
  const [webJobExperience, setWebjobExperience] = useState("");
  const [webSecondlanguagelist, setWebSecondLanguage] = useState("");
  const [webmaritalstatus, setWebMaritalStatus] = useState("");
  const [webaptabilityfactors, setWebaptabilityfactors] = useState("");
  const [webservice, setWebService] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhoneNumber] = useState("");
  const [age, setAge] = useState("");
  const [pages, setPages] = useState([]);
  const [dropdownjobexperience, setDropDownJobExperience] = useState("");
  const [dropdownrating, setDropdownRating] = useState("");
  const [dropwnsecondlanguage, setDropDownSecondLanguage] = useState("");
  const [dropdownservices, setDropDownServices] = useState("");
  const [checkeligibilitieslist, setEligibilitieslist] = useState("");
  const [loading, setLoading] = useState(true);
  const [educationdropdown, setEducationDropDown] = useState("");
  const [dropdownadaptability, setDropDownAdaptaBility] = useState("");
  const [nameerr, setNameErr] = useState("");
  const [emailerr, setEmaiErr] = useState("");
  const [phonenumbererr, setPhonenumberErr] = useState("");
  const [ageerr, setAgeErr] = useState("");
  const [languageratingerr, setLanguageRatingErr] = useState("");
  const [educationerr, setEducationErr] = useState("");
  const [jobexperienceerr, setJonExperienceErr] = useState("");
  const [secondlanguageerr, setSecondLanguageErr] = useState("");
  const [jobstatuserr, setJobStatusErr] = useState("");
  const [capabilityfactorserr, setCapabilityFactorsErr] = useState("");
  const [serviceserr, setServicesErr] = useState("");
  const [success, setSuccess] = useState("");
  const [success1, setSuccess1] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (selectedLanguage.id) setName("");
    setNameErr("");
    setEmaiErr("");
    setEmail("");
    setPhoneNumber("");
    setPhonenumberErr("");
    setDropdownRating("");
    setLanguageRatingErr("");
    setEducationDropDown("");
    setEducationErr("");
    setDropDownJobExperience("");
    setJonExperienceErr("");
    setDropDownSecondLanguage("");
    setAge("");
    setAgeErr("");
    setStatus("");
    setJobStatusErr("");
    setDropDownAdaptaBility("");
  }, [selectedLanguage.id]);
  const navigate = useNavigate();
  const home = () => {
    navigate("/");
  };

  useEffect(() => {
    if (selectedLanguage.id) languagerating();
    webhighesteducationlist();
    webjobexperience();
    websecondlanguagelist();
    webMaritalstatus();
    webAptabilityfactors();
    webservicelist();
    checkeligibilitiesList();
  }, [selectedLanguage.id]);

  const languagerating = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("weblanguagerating_list/webCondition", req).then((res) => {
      if (res.data.success === true);
      setWebLanguageRatingList(res.data.data.data);
    });
  };

  const webhighesteducationlist = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webhighesteducation_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setWebHeightEducation(res.data.data.data);
      }
    });
  };

  const webjobexperience = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webjobexperience_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setWebjobExperience(res.data.data.data);
      }
    });
  };

  const websecondlanguagelist = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("websecondlanguage_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setWebSecondLanguage(res.data.data.data);
      }
    });
  };

  const webMaritalstatus = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webmaritalstatus_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setWebMaritalStatus(res.data.data.data);
      }
    });
  };

  const webAptabilityfactors = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webadaptabilityfactors_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setWebaptabilityfactors(res.data.data.data);
      }
    });
  };

  const webservicelist = () => {
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webServices_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setWebService(res.data.data.data);
      }
    });
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleWenLangugage = (e) => {
    const values = Number(e.target.value);
    setDropdownRating(values);
    updatePages(0, values);
  };

  const handleheightEducation = (e) => {
    const values = Number(e.target.value);
    setEducationDropDown(values);
    updatePages(1, values);
  };

  const handlejobexperience = (e) => {
    const values = Number(e.target.value);
    setDropDownJobExperience(values);
    updatePages(2, values);
  };

  const handleSecondlanguage = (e) => {
    const values = Number(e.target.value);
    setDropDownSecondLanguage(values);
    updatePages(3, values);
  };

  const handleStatus = (e) => {
    const values = Number(e.target.value);
    setStatus(values);
    updatePages(4, values);
  };

  const handleAdaptability = (e) => {
    const values = Number(e.target.value);
    setDropDownAdaptaBility(values);
    updatePages(5, values);
  };

  const handleradioservices = (e) => {
    const values = Number(e.target.value);
    setDropDownServices(values);
  };

  const checkeligibilitiesList = () => {
    setLoading(true);
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webCheckEligibilities/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setEligibilitieslist(res.data.data.data[0]);
        setLoading(false);
      }
    });
  };

  const handlephoneNumberChange = (e) => {
    setPhonenumberErr("");
    const value = e.target.value;
    const values = value.replace(/[^0-9]/g, "");
    const values1 = values.slice(0, 10);
    setPhoneNumber(values1);
    if (values1.length !== 10) {
      setPhonenumberErr(
        selectedLanguage.id === 1
          ? "Phone Number Must Be 10 Digits"
          : "Le numéro de téléphone doit contenir 10 chiffres",
      );
      return;
    }
  };

  const handleEmailChange = (e) => {
    setEmaiErr("");
    const value = e.target.value;
    setEmail(value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      setEmaiErr(
        selectedLanguage.id === 1
          ? "Enter a Valid Email Address"
          : "Veuillez entrer une adresse e-mail valide",
      );
      return;
    }
  };
  const updatePages = (index, value) => {
    setPages((prev) => {
      const arr = [...prev];
      arr[index] = value;
      return arr;
    });
  };

  const checkEligibilityAdd = () => {
    setNameErr("");
    setEmaiErr("");
    setPhonenumberErr("");
    setLanguageRatingErr("");
    setAgeErr("");
    setEducationErr("");
    setJonExperienceErr("");
    setSecondLanguageErr("");
    setJobStatusErr("");
    setCapabilityFactorsErr("");
    setServicesErr("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    let phoneNumber = phonenumber;
    phoneNumber = phoneNumber.replace(/[^0-9]/g, "");
    phoneNumber = phoneNumber.slice(0, 10);

    setPhoneNumber(phoneNumber);

    if (!name) {
      setNameErr(
        selectedLanguage.id === 1 ? "Name Is Required" : "Le nom est requis",
      );
      return;
    } else if (!email) {
      setEmaiErr(
        selectedLanguage.id === 1
          ? "Email Is Required"
          : "L’adresse e-mail est requise",
      );
      return;
    } else if (!emailRegex.test(email)) {
      setEmaiErr(
        selectedLanguage.id === 1
          ? "Enter a Valid Email Address"
          : "Veuillez entrer une adresse e-mail valide",
      );
      return;
    } else if (!phonenumber) {
      setPhonenumberErr(
        selectedLanguage.id === 1
          ? "Phone Number Is Required"
          : "Le numéro de téléphone est requis",
      );
      return;
    } else if (phonenumber.length !== 10) {
      setPhonenumberErr(
        selectedLanguage.id === 1
          ? "Phone Number Must Be 10 Digits"
          : "Le numéro de téléphone doit contenir 10 chiffres",
      );
      return;
    } else if (!dropdownrating) {
      setLanguageRatingErr(
        selectedLanguage.id === 1
          ? "First Language Rating Is Required"
          : "La note de la première langue est requise",
      );
      return;
    } else if (!educationdropdown) {
      setEducationErr(
        selectedLanguage.id === 1
          ? "Highest Education Is Required"
          : "Le niveau d’éducation le plus élevé est requis",
      );
      return;
    } else if (!dropdownjobexperience) {
      setJonExperienceErr(
        selectedLanguage.id === 1
          ? "Job Experience Is Required"
          : "L’expérience professionnelle est requise",
      );
      return;
    } else if (!age) {
      setAgeErr(
        selectedLanguage.id === 1 ? "Age Is Required" : "L’âge est requis",
      );
      return;
    } else if (!status) {
      setJobStatusErr(
        selectedLanguage.id === 1
          ? "Status Is Required"
          : "Le statut est requis",
      );
      return;
    }

    let req = {
      language_id: selectedLanguage.id,
      name: name,
      email: email,
      phone_number: phonenumber,
      eligibilitypoints_id: `[${pages.filter((x) => x !== 0 && x !== "" && x !== undefined).join(",")}]`,
      age: Number(age),
      eligibility_status: "pending",
      createdBy: 1,
      updatedBy: 1,
    };
    API.post("webAdd_checkeligibilityform/add1", req).then((res) => {
      if (res.data.success === true) {
        setSuccess1(res.data.message);
        setSuccess(res.data.data.points);
      }
    });
  };

  return (
    <div style={{ overflowX: "hidden" }}>

      {showHeader !== false && (
        <SEO
          title="Canada study visa consultant| Canadian immigration advisor"
          description="Check your eligibility with ASRA Immigration. Trusted Canada study visa consultant helping students assess profiles and plan successful study pathways."
          canonical="https://asraimmigration.ca/checkeligibility"
        />
      )}

      {loading ? (
        <div
          className="d-flex justify-content-center mt-5 align-items-center p-5"
          style={{ height: "100vh" }}
        >
          <ClipLoader color="#FF050C" size={50} />
        </div>
      ) : (
        <>
          <div class="container px-3">
            {showHeader && (
              <section class="faq-hero container p-5 rounded-5 mt-5">
                <h1>
                  {selectedLanguage.id === 1
                    ? "Check Eligibility"
                    : "Vérifier l’éligibilité"}
                </h1>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item cursorpointer" onClick={home}>
                      <a>{selectedLanguage.id === 1 ? "Home" : "Accueil"}</a>
                    </li>
                    <li class="breadcrumb-item active">
                      {selectedLanguage.id === 1
                        ? "Check Eligibility"
                        : "Vérifier l’éligibilité"}
                    </li>
                  </ol>
                </nav>
              </section>
            )}
          </div>

          <section className="container gap-2 my-5 ">
            <div class="form-title">
              <p className="form-heading mb-3">
                {checkeligibilitieslist ? checkeligibilitieslist.title : ""}
              </p>
              <h2 className="form-heading mb-3">
                {checkeligibilitieslist ? checkeligibilitieslist.heading : ""}
              </h2>
              <p
                className="info-box"
                dangerouslySetInnerHTML={{
                  __html: checkeligibilitieslist
                    ? checkeligibilitieslist.description
                    : "",
                }}
              ></p>
            </div>
            <div className="shadow-lg p-3 mb-5 lightpink col-lg-8 col-md-8 d-block mx-auto mt-5">
              <div className="row">
                <h5 className="base-clr mb-3 mt-2 ms-4 fw-bold">
                  {selectedLanguage.id === 1
                    ? "Check Eligibility"
                    : "Vérifier l’éligibilité"}
                </h5>
              </div>

              <div className="row px-4 marginbottom">
                <div className="col-lg-6 form-outline mb-2">
                  <label className="form-label ms-2 nameinput" for="typeText">
                    {selectedLanguage.id === 1 ? "Name" : "Nom"}{" "}
                    <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    placeholder={
                      selectedLanguage.id === 1
                        ? "Enter Your Name"
                        : "Entrez votre nom"
                    }
                    id="typeText"
                    className="form-control inputsheight"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <p className="text-start text-danger mt-2">{nameerr}</p>
                </div>

                <div className="col-lg-6 form-outline mb-2">
                  <label className="form-label ms-2 nameinput" for="typeText">
                    {selectedLanguage.id === 1 ? "Email" : "E-mail"}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder={
                      selectedLanguage.id === 1
                        ? "Enter Your Email"
                        : "Entrez votre e-mail"
                    }
                    id="typeText"
                    className="form-control inputsheight"
                    value={email}
                    onChange={handleEmailChange}
                  />
                  <p className="text-start text-danger mt-2">{emailerr}</p>
                </div>

                <div className="col-lg-6 form-outline mb-2">
                  <label className="form-label ms-2 nameinput" for="typeText">
                    {selectedLanguage.id === 1
                      ? "Phone Number"
                      : "Numéro de téléphone"}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder={
                      selectedLanguage.id === 1
                        ? "Enter Your Number"
                        : "Entrez votre numéro"
                    }
                    id="typeText"
                    className="form-control inputsheight"
                    value={phonenumber}
                    onChange={handlephoneNumberChange}
                  />
                  <p className="text-start text-danger mt-2">
                    {phonenumbererr}
                  </p>
                </div>
                <div className="col-lg-6 form-outline mb-2">
                  <label
                    className="form-label ms-2 nameinput"
                    for="selectOption"
                  >
                    {selectedLanguage.id === 1
                      ? " 1st Language Rating"
                      : "Évaluation de la première langue"}{" "}
                    <span className="text-danger">*</span>
                  </label>

                  <div className="dropdown-wrapper">
                    <select
                      id="selectOption"
                      className="form-control inputsheight dropdown-select"
                      value={dropdownrating}
                      onChange={handleWenLangugage}
                    >
                      <option value="">
                        --{" "}
                        {selectedLanguage.id === 1 ? "Select" : "Sélectionner"}{" "}
                        --
                      </option>
                      {Array.isArray(weblanguageratinglist) &&
                        weblanguageratinglist.length > 0
                        ? weblanguageratinglist.map((item, index) => (
                          <option
                            value={item.eligibilitypoints_id}
                            key={item.eligibilitypoints_id}
                          >
                            {item.points_name}
                          </option>
                        ))
                        : null}
                    </select>
                    <p className="text-start text-danger mt-2">
                      {languageratingerr}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 form-outline mb-2">
                  <label
                    className="form-label ms-2 nameinput"
                    for="selectOption"
                  >
                    {selectedLanguage.id === 1
                      ? "Highest Education"
                      : "Niveau d'études le plus élevé"}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="dropdown-wrapper">
                    <select
                      id="selectOption"
                      className="form-control inputsheight dropdown-select"
                      value={educationdropdown}
                      onChange={handleheightEducation}
                    >
                      <option value="">
                        --{" "}
                        {selectedLanguage.id === 1 ? "Select" : "Sélectionner"}{" "}
                        --
                      </option>
                      {Array.isArray(webhighesteducation) &&
                        webhighesteducation.length > 0
                        ? webhighesteducation.map((item, index) => (
                          <option
                            value={item.eligibilitypoints_id}
                            key={item.eligibilitypoints_id}
                          >
                            {item.points_name}
                          </option>
                        ))
                        : null}
                    </select>
                    <p className="text-start text-danger mt-2">
                      {educationerr}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 form-outline mb-2">
                  <label
                    className="form-label ms-2 nameinput"
                    for="selectOption"
                  >
                    {selectedLanguage.id === 1
                      ? "Job Experience"
                      : "Expérience professionnelle"}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="dropdown-wrapper">
                    <select
                      id="selectOption"
                      className="form-control inputsheight dropdown-select"
                      value={dropdownjobexperience}
                      onChange={handlejobexperience}
                    >
                      <option value="">
                        --{" "}
                        {selectedLanguage.id === 1 ? "Select" : "Sélectionner"}{" "}
                        --
                      </option>
                      {Array.isArray(webJobExperience) &&
                        webJobExperience.length > 0
                        ? webJobExperience.map((item, index) => (
                          <option
                            value={item.eligibilitypoints_id}
                            key={item.eligibilitypoints_id}
                          >
                            {item.points_name}
                          </option>
                        ))
                        : null}
                    </select>
                    <p className="text-start text-danger mt-2">
                      {jobexperienceerr}
                    </p>
                  </div>
                </div>

                <div className="col-lg-6 form-outline mb-2">
                  <label
                    className="form-label ms-2 nameinput"
                    for="selectOption"
                  >
                    {selectedLanguage.id === 1
                      ? "2nd Language Rating"
                      : "Évaluation de la deuxième langue"}
                  </label>
                  <div className="dropdown-wrapper">
                    <select
                      id="selectOption"
                      className="form-control inputsheight dropdown-select"
                      value={dropwnsecondlanguage}
                      onChange={handleSecondlanguage}
                    >
                      <option value="">
                        --{" "}
                        {selectedLanguage.id === 1 ? "Select" : "Sélectionner"}{" "}
                        --
                      </option>
                      {Array.isArray(webSecondlanguagelist) &&
                        webSecondlanguagelist.length > 0
                        ? webSecondlanguagelist.map((item, index) => (
                          <option
                            value={item.eligibilitypoints_id}
                            key={item.eligibilitypoints_id}
                          >
                            {item.points_name}
                          </option>
                        ))
                        : null}
                    </select>
                  </div>
                </div>

                <div className="col-lg-6 form-outline mb-2">
                  <label className="form-label ms-2 nameinput" for="typeText">
                    {selectedLanguage.id === 1 ? "Age" : "Âge"}
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder={
                      selectedLanguage.id === 1
                        ? "Enter Your Age"
                        : "Entrez votre âge"
                    }
                    id="typeText"
                    className="form-control inputsheight"
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                  />
                  <p className="text-start text-danger mt-2">{ageerr}</p>
                </div>

                <div className="col-lg-6 form-outline">
                  <p className="text-start services1">
                    {selectedLanguage.id === 1
                      ? "Valid job offer"
                      : "Offre d'emploi valide"}
                    <span className="text-danger">*</span>
                  </p>
                  <div className="directioncolumn mt-3">
                    <div className="d-flex">
                      {Array.isArray(webmaritalstatus) &&
                        webmaritalstatus.length > 0
                        ? webmaritalstatus.map((item, index) => (
                          <div className=" me-3">
                            <input
                              type="radio"
                              id="expressentry"
                              name="service"
                              value={item.eligibilitypoints_id}
                              checked={status === item.eligibilitypoints_id}
                              onChange={handleStatus}
                            />
                            <label htmlFor="expressentry" className="ms-2">
                              {item.points_name}
                            </label>
                          </div>
                        ))
                        : null}
                    </div>
                    <p className="text-start text-danger mt-2">
                      {jobstatuserr}
                    </p>
                  </div>
                </div>

                <div className="col-lg-6 form-outline">
                  <label
                    className="form-label ms-2 nameinput"
                    for="selectOption"
                  >
                    {selectedLanguage.id === 1
                      ? "Adaptability Factors"
                      : "Facteurs d’adaptabilité"}
                  </label>
                  <div className="dropdown-wrapper">
                    <select
                      id="selectOption"
                      className="form-control inputsheight dropdown-select"
                      value={dropdownadaptability}
                      onChange={handleAdaptability}
                    >
                      <option value="">
                        --{" "}
                        {selectedLanguage.id === 1 ? "Select" : "Sélectionner"}{" "}
                        --
                      </option>
                      {Array.isArray(webaptabilityfactors) &&
                        webaptabilityfactors.length > 0
                        ? webaptabilityfactors.map((item, index) => (
                          <option
                            value={item.eligibilitypoints_id}
                            key={item.eligibilitypoints_id}
                          >
                            {item.points_name}
                          </option>
                        ))
                        : null}
                    </select>
                  </div>
                </div>
                <div className="col-12 d-flex justify-content-end mt-2 mb-4">
                  <button
                    className="btn ckeckeligibilitybutton"
                    onClick={checkEligibilityAdd}
                  >
                    {selectedLanguage.id === 1
                      ? "Check Eligibility"
                      : " Vérifier l’éligibilité"}
                  </button>
                </div>

                {/* {success1 && (
                  <div className=" score-result mt-3 d-flex flex-column justify-content-center align-items-center">
                    <h4 className="fw-bold fst-italic">Your Score</h4>
                    <h1 className="text-start fw-semibold fst-italic points">
                      {success}%
                    </h1>
                  </div>
                )} */}

                {success1 && (
                  <div className="score-result mt-3 d-flex flex-column justify-content-center align-items-center">
                    <span className="score-label">
                      {selectedLanguage.id === 1 ? "Your Score" : "Votre score"}
                    </span>
                    <div className="score-badge" style={{ "--score": success }}>
                      <span className="points">{success}%</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};
export default CheckEligibility;
